import './togglables';
import './scroll';

import { DefaultEventManager } from '@paperbits/common/events/defaultEventManager';
// import { XmlHttpRequestClient } from '@paperbits/common/http';
import type { IInjector, IInjectorModule } from '@paperbits/common/injection';
import { LocationRouteHandler } from '@paperbits/common/routing/locationRouteHandler';
import { VisibilityGuard } from '@paperbits/common/user/visibilityGuard';
import { KnockoutRegistrationLoaders } from '@paperbits/core/ko/knockout.loaders'; // FIXME(injector)
import { CustomHistoryRouteHandler } from '../../routing/customHistoryRouteHandler';
import { StaticRoleService } from '../../user/staticRoleService';
import { StaticUserService } from '../../user/staticUserService';
import { KoRuntimeModule } from './ko/ko.runtime.module';
// import { WidgetBindingHandler } from '@paperbits/core/ko/bindingHandlers/bindingHandlers.widget';

export class CoreRuntimeModule implements IInjectorModule {

    constructor(private readonly designtime: boolean) {}

    public register(injector: IInjector): void {
        injector.bindModule(new KnockoutRegistrationLoaders());
        injector.bindModule(new KoRuntimeModule());
        injector.bindSingletonFactory('eventManager', () => new DefaultEventManager());
        injector.bindCollection('autostart');
        injector.bindCollection('routeGuards');
        // injector.bindSingleton('router', CustomRouter);
        injector.bindSingletonFactory('userService', () => new StaticUserService());
        injector.bindSingletonFactory('roleService', () => new StaticRoleService());
        injector.bindToCollection('autostart', VisibilityGuard); // FIXME(injector)
        injector.bindToCollection('autostart', this.designtime // FIXME(injector)
            ? CustomHistoryRouteHandler
            : LocationRouteHandler);
        // injector.bindToCollection('autostart', WidgetBindingHandler);
    }
}
